import React from 'react';
import { Paper } from '@mui/material';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import ContentArea from '../components/content-area/Content';
import GameScheduleSection from '../components/gameSchedule/GameScheduleSection';
import { usePermissions } from '../hooks/usePermissions';
import { cardBase } from '../theme/adminTokens';
import { GAME_SCHEDULE_EDIT_FEATURE, GAME_SCHEDULE_ROUTE } from '../constants/gameSchedule';

/**
 * Game Schedule — schedule a game (today the Quiz) for a period, build its questions, preview it and send it for
 * approval. space_admin and marketing manage it; marketing_manager can view it and its participants (approving is
 * done in the Approvals screen). The access rules live in permissions.js (NAV_ACCESS['/game-schedule']).
 */
export default function GameSchedule() {
  const canManage = usePermissions().canFeature(GAME_SCHEDULE_ROUTE, GAME_SCHEDULE_EDIT_FEATURE);

  return (
    <ContentArea title="Game Schedule" icon={<EventAvailableOutlinedIcon />}>
      {/* flexGrow: the card stretches to the page height like the Game Score Board cards do. */}
      <Paper elevation={0} sx={{ ...cardBase, '&:hover': {}, p: { xs: 2, sm: 3 }, flexGrow: 1 }}>
        <GameScheduleSection canManage={canManage} />
      </Paper>
    </ContentArea>
  );
}
